import { useMutation } from "@tanstack/react-query";
import { apiFetch } from "../APIClient";
import { SignupUserWithKakaoRequestDto, UserSummaryDto } from "../generated/generatedTypes";
import { getUtmFromCookie } from "../../utils/utm";

const signupWithKakao = async (data: SignupUserWithKakaoRequestDto): Promise<UserSummaryDto> => {
  const utm = getUtmFromCookie();
  const response = await apiFetch("api/users/kakao-signup", {
    method: "POST",
    body: JSON.stringify({ ...data, ...(utm && { utm }) }),
    headers: {
      "Content-Type": "application/json",
    },
  });
  if (!response.ok) {
    const error = await response.json();
    throw new Error(
      error?.error?.message ||
        error?.message ||
        "Something went wrong signing up. Please try again shortly."
    );
  }
  return response.json();
};

export function useSignupWithKakao() {
  return useMutation<UserSummaryDto, Error, SignupUserWithKakaoRequestDto>({
    mutationFn: signupWithKakao,
  });
}
